export interface IViewTransformationSizes {
  oldRows: number;
  oldCols: number;
  oldFrames: number;
  newRows: number;
  newCols: number;
  newFrames: number;
}
